import { render, staticRenderFns } from "./third-agm-list.vue?vue&type=template&id=5819099a&scoped=true&"
import script from "./third-agm-list.vue?vue&type=script&lang=js&"
export * from "./third-agm-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819099a",
  null
  
)

export default component.exports